// کلاس‌های بخش‌هایی از فرم که خود core می‌کشد و اینپوت سایتی ندارند: فیلد تاریخ (سه لیست)، فیلد سفارشی‌ای که کامپوننت ندارد (جعبه‌ی
// متنی ساده)، و نمونه‌ها و دکمه‌های گروه تکرارشونده. class_names جای ماژول CSS پیش‌فرض core را کامل می‌گیرد، پس بدون این‌ها هر کدام
// از این بخش‌ها که مدیر در فرمی بگذارد بی‌استایل دیده می‌شود. ظاهرشان مثل اینپوت‌های ژومنت (TextInput) است.
// هر فرم این را با کلاس‌های قاب خودش (form_root، group_*، grid_*) یکی می‌کند.
export const CORE_PART_CLASS_NAMES = {
	// فیلد
	root: "mb-7 flex flex-col",
	label: "relative mb-1.5 min-h-5 text-sm font-medium text-jmt-main",
	required_mark: "text-red-600",
	input: "w-full min-h-[41px] rounded-md border border-jmt-neutral-300 bg-transparent px-3 py-2 text-sm text-jmt-main outline-0 transition-all duration-200 hover:border-jmt-neutral-500 focus:ring-2 focus:ring-jmt-neutral-600 focus:ring-offset-2 aria-[invalid=true]:border-jmt-red-500 disabled:cursor-not-allowed disabled:text-jmt-neutral-300",
	hint: "mt-1.5 text-xs text-jmt-neutral-500",
	error: "mt-1.5 text-xs text-jmt-red-600",
	is_invalid: "",
	is_disabled: "",
	date_parts: "grid grid-cols-3 gap-2",

	// گروه تکرارشونده
	group_instance: "flex flex-col gap-4 rounded-md border border-dashed border-jmt-neutral-300 p-4",
	instance_header: "flex items-center justify-between gap-3",
	instance_title: "text-sm font-bold text-jmt-main",
	group_actions: "flex",
	group_button: "cursor-pointer disabled:cursor-not-allowed disabled:opacity-50",
	add_button: "rounded-md border border-jmt-neutral-300 px-3 py-2 text-sm font-bold text-jmt-main hover:bg-jmt-neutral-100",
	remove_button: "rounded-md px-2 py-1 text-xs text-jmt-red-600 hover:bg-jmt-neutral-100",
};

// ۳ و ۴ ستون در موبایل نیم‌عرض و ۶ و ۱۲ تمام‌عرض می‌شوند (زیر lg)
export const GRID_CLASS_NAMES = {
	grid_3: "col-span-6 lg:col-span-3",
	grid_4: "col-span-6 lg:col-span-4",
	grid_6: "col-span-12 lg:col-span-6",
	grid_12: "col-span-12",
};
